module.exports = __webpack_public_path__ + "static/img/Michael-Asomua.e86ac67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Michael-Asomua.jpg
// module id = RxkF
// module chunks = 0